<div class="dropdown-wrapper" [class.disabled]="disabled" [class.error]="error">
    <eap-input *ngIf="!isWorkAsButton" [allowToShowPlaceHolder]="true" [label]="label" [placeholder]="placeholder" [disabled]="disabled" [error]="error" [showButton]="true"
        [buttonIcon]="isOpen() ? 'expand_less' : 'expand_more'" [formControl]="control" [showLargeIcon]="showLargeIcon"
        [isInputReadOnly]="isInputReadOnly" (click)="toggleDropdown()"></eap-input>
    
    <eap-button *ngIf="isWorkAsButton" [label]="label" [disabled]="disabled" [error]="error" [icon]="isOpen() ? 'expand_less' : 'expand_more'"
        (click)="toggleDropdown()" [iconPosition]="'end'"></eap-button>

    <ul class="dropdown-list" *ngIf="isOpen() && !isMultiSelect">
        <li class="dropdown-option" *ngFor="let option of options" (click)="selectOption(option)"
            [ngClass]="{ selected: selected()?.value === option.value }">
            <mat-icon *ngIf="option.icon" class="material-symbols-outlined dropdown-option-icon" aria-hidden="true">
                {{ option.icon }}
            </mat-icon>
            {{ option.label }}
        </li>
    </ul>

    <ul class="dropdown-list" *ngIf="isOpen() && isMultiSelect">
        <li class="dropdown-option" *ngFor="let option of options" (click)="selectOption(option)"
            [ngClass]="{ selected: selected()?.value === option.value }">
            <mat-checkbox 
                [checked]="isChecked(option)"
                (change)="toggleMultiSelect(option, $event)">
            </mat-checkbox>
            <mat-icon *ngIf="option.icon" class="material-symbols-outlined dropdown-option-icon" aria-hidden="true">
                {{ option.icon }}
            </mat-icon>
            {{ option.label }}
        </li>
    </ul>

</div>